var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-container"},[_c('div',{staticClass:"container"},[_c('h2',[_vm._v(_vm._s(_vm.isCoupang ? '쿠팡 1P/2P 전용 서비스' : '사업자 회원'))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }